const s = (t) => t ? (Array.isArray(t) ? t.map((r) => [
  r.key,
  r
]) : Object.entries(t)).filter(([, r]) => typeof (r == null ? void 0 : r.sort) == "string").map(([r, e]) => ({
  id: r,
  desc: (e == null ? void 0 : e.sort) === "desc"
})) : [];
export {
  s as composeIDSTableInitialSorting
};
